import { customAxios, USERNAME, IDUSUARIO, FDV_URL } from '../constants';

export default function(fdvID, codigo, obsCambioEstado, destinatarios) {
  let contenido;
  const numCorrelativoPadre = parseInt(fdvID, 10);

  switch (codigo) {
    case 'I':
      contenido = 'ANULADA';
      break;
    case 'E':
      contenido = 'CERRADA';
      break;
    case 'V':
      contenido = 'VIGENCIA';
      break;
    default:
      contenido = '';
  }

  const data = {
    observacion: obsCambioEstado.replace(/\n/g, "<br />"),
    usuarioRegistro: USERNAME,
    codTipAct: '3',
    numCorrelativoPadre: `${numCorrelativoPadre}.01`,
    tipoRefProc: 'FV',
    tipoCorreo: '1',
    contenido,
    destinatarios,
  };

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  return customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/estado/${codigo}`, data, config);
}



// WEBPACK FOOTER //
// ./src/utils/updateState.js